import { createContext, useContext } from "react";
import IAuthContext from "../../modal/Auth";
// import { AlertColor } from "@mui/material/Alert";

const defaultState: IAuthContext = {
  isAuthenticated: false,
  isAuthorized: false,
  roleType: "",
  authId: null,
  loading: false,
  isPortalAuthenticated: false,
};

const AuthContext = createContext<IAuthContext>(defaultState);

// Create a custom hook for using AuthContext
export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within a AuthProvider");
  }
  return context;
};

export default AuthContext;
